// extracted by mini-css-extract-plugin
export default {"wrapper":"Message_wrapper__PGwOk","author":"Message_author__78WMp","channel":"Message_channel__3pzyh","name":"Message_name__ym9F9","contentWrapper":"Message_contentWrapper__yuzEm"};